import { render, staticRenderFns } from "./SSelectDefinitionExtern.vue?vue&type=template&id=1153a9d2&"
import script from "./SSelectDefinitionExtern.vue?vue&type=script&lang=js&"
export * from "./SSelectDefinitionExtern.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports